module.exports = "/fonts/fa-regular-400.woff?f89ea91ecd1ca2db7e09baa2c4b156d1";